module.exports = __webpack_public_path__ + "static/media/thumbnail.cd1c3835.jpg";